import { Component, ElementRef, EventEmitter, HostListener, inject, Input, Output, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { AppCountry } from 'src/app/app.models';
import { config as countryConfig } from 'src/app/config/country-config';
import { FirebaseService } from 'src/app/services/firebase.service';
import { UtilsService } from 'src/app/services/utils.service';
import { isValidE164PhoneNumber } from 'src/app/feature/sign-in/utils/phone-utils';

import { Auth } from '@angular/fire/auth';
import { UserPhoneDetails } from 'src/app/models/sign-in.models';

@Component({
    selector: 'app-request-otp',
    templateUrl: './request-otp.component.html',
    styleUrls: ['./request-otp.component.scss'],
    standalone: false
})
export class RequestOtpComponent {
  @ViewChild('inputPhone') public inputElement: ElementRef;
  @HostListener('document:click', ['$event']) clickOutside(event: MouseEvent){
    const targetElement = event.target as HTMLElement;
    if (this.inputElement && !this.inputElement.nativeElement.contains(targetElement)) {
      if (this.isDropDownOpen === true) {
        this.isDropDownOpen = false;
      }
    }
  };
  @Output() requestOtpEvent = new EventEmitter<UserPhoneDetails>();

  @Input() isRecaptchaSolved: boolean; // Todo: remove: May not need this...
  @Input() cmsLabels: any // Todo: Tim: fix types

  public countryList: AppCountry[] = countryConfig;
  public isDropDownOpen: boolean = false;
  private defaultFormValues = {
    iso2CountryCode: 'US',
    phoneNumber: '',
    dialCountryCode: '1',
    internationalPhoneNumber: ''
  }

  // TODO: Tim: May need to add more validation checks, particularly for phone numbers before submission.
  public phoneForm = this.fb.group({
    iso2CountryCode: ['US', Validators.required],
    phoneNumber: ['', Validators.required],
    dialCountryCode: ['1', Validators.required],
    internationalPhoneNumber: ['', [Validators.required, Validators.maxLength(16), Validators.minLength(2)]]
  })

  constructor(
      private fb: FormBuilder, 
      private utilsService: UtilsService, 
      public firebaseService: FirebaseService, 
      public auth: Auth
    ) {}

  public isValidE164NumberFormat = isValidE164PhoneNumber;

  ngOnInit() {
    // TODO: TIM: Do we need to manually unsubscribe?
    this.phoneForm.get('iso2CountryCode')?.valueChanges.subscribe(value => {
      this.updateDialCodeFormValue(value);
      this.formatPhoneFormValue();
      this.updateInternationalPhoneFormValue();
    })

    this.phoneForm.get('phoneNumber')?.valueChanges.subscribe(value => {
      this.formatPhoneFormValue();
      this.updateInternationalPhoneFormValue();
    })
  }

  confirmationResult: any;
  verificationCode: string = '';

  requestOTP() {
    const intlPhone = this.getInternationalPhoneNumber();
    let userPhone = this.phoneForm.get('phoneNumber')?.value || '';
    userPhone = this.utilsService.formatToRawPhoneNumber(userPhone.trim());
    const userDialCode = this.phoneForm.get('dialCountryCode')?.value || '';
    // console.log('userPhone', userPhone); // Todo: Remove:
    // console.log('userDialCode', userDialCode); // Todo: Remove:
    
    const userPhoneDetails = {
      phoneNumber: userPhone,
      countryDialCode: userDialCode,
      internationalPhoneNumber: intlPhone
    }

    if (intlPhone !== null) {
      this.requestOtpEvent.emit(userPhoneDetails);
    }
    else {
      console.log('phone is null');
      // Todo: Tim: Need to add an #error here to display to the user
    }
  }

  public getInternationalPhoneNumber(): string {
    const dialCode = this.phoneForm.get('dialCountryCode')?.value || '';
    const phoneNumber = this.phoneForm.get('phoneNumber')?.value || '';
    const rawPhoneNumber = this.utilsService.formatToRawPhoneNumber(phoneNumber.trim());
    // Todo: Tim: The Intl Phone could be another form value that is updated whenever the base phone or dial code is updated. That may be better since we could use the reactive form validators to check it, and disable the Request Otp button accordingly.
    const internationalPhone = '+' + dialCode.trim() + rawPhoneNumber.trim();
    if (internationalPhone !== null && internationalPhone !== undefined && this.isValidE164NumberFormat(internationalPhone)) {
      return internationalPhone;
    }
    else {
      console.log('NOT VALID international phone number...'); // TODO: Tim: Add user friendly #error here
      return '';
    }
  }

  private formatPhoneFormValue(): void {
    let formattedPhoneNumber = '';
    const phoneFromForm = this.phoneForm.get('phoneNumber')?.value || '';
    const iso2Code = this.phoneForm.get('iso2CountryCode')?.value;
    if (!!phoneFromForm && phoneFromForm.length > 1 && iso2Code) {
      formattedPhoneNumber = this.utilsService.formatPhoneNumber(phoneFromForm, iso2Code)
      this.phoneForm.get('phoneNumber')?.setValue(formattedPhoneNumber, { emitEvent: false })
    }
  }

  private generateInternationalPhoneNumber(phoneNumber: string, dialCode: string): string {
    const phone = !!phoneNumber ? phoneNumber : '';
    const dial = !!dialCode ? dialCode : '';

    const formattedPhoneNumber = this.utilsService.formatToRawPhoneNumber(phone.trim());
    return '+' + dial.trim() + formattedPhoneNumber.trim();
  }

  private updateDialCodeFormValue(iso2CountryCode: string | number | null) {
    if (!iso2CountryCode) return;
      // Todo: Tim: fix || case
    const updatedDialCode = this.countryList.find((countryConfig) => countryConfig.iso2Code === iso2CountryCode)?.countryDialingCode || '1';
      this.phoneForm.get('dialCountryCode')?.setValue(updatedDialCode.toString())
  }

  private updateInternationalPhoneFormValue() {
    const phoneNumber = this.phoneForm.get('phoneNumber')?.value;
    const dialCountryCode = this.phoneForm.get('dialCountryCode')?.value;
    const iso2CountryCode = this.phoneForm.get('iso2CountryCode')?.value;
    if (!!phoneNumber && !!dialCountryCode && !!iso2CountryCode) {
      const formattedPhone = this.generateInternationalPhoneNumber(phoneNumber, dialCountryCode);
      this.phoneForm.get('internationalPhoneNumber')?.setValue(formattedPhone);
    };
  }

  public resetPhoneForm() {
    this.phoneForm.reset(this.defaultFormValues);
  }

  public toggleDropDown() {
    this.isDropDownOpen = !this.isDropDownOpen
  }

  public selectCountry(country: AppCountry) {
    this.phoneForm.get('iso2CountryCode')?.setValue(country.iso2Code)
    this.isDropDownOpen = false;
  }
}
